export default __webpack_public_path__ + "static/media/007-star-red.a5b53e65.svg";